import { axiosInstanceWithToken } from "../utils/Client";

export default class PTOService {

    static getJobTitle = (locationId) => {
        return axiosInstanceWithToken.get(`/agency_job_titles/${locationId}/`);
    };

    static getPTOSetting = (locationId, year) => {
        return axiosInstanceWithToken.get(`/pto/setting/${locationId}/?year=${year}`);
    };

    static savePTOSetting = (locationId, settingObj, year) => {
        return axiosInstanceWithToken.put(
            `/pto/setting/${locationId}/?year=${year}`, settingObj
        );
    };

    static getPTOTypeList = (locationId) => {
        return axiosInstanceWithToken.get(`/pto/type/list/${locationId}/`);
    };

    static createPTOType = (locationId, ptoTypeObj) => {
        return axiosInstanceWithToken.post(`/pto/type/list/${locationId}/`, ptoTypeObj);
    };

    static updatePTOType = (ptoTypeObj) => {
        return axiosInstanceWithToken.put(`/pto/type/${ptoTypeObj.id}/`, ptoTypeObj);
    };

    static deletePTOType = (ptoTypeId) => {
        return axiosInstanceWithToken.delete(`/pto/type/${ptoTypeId}/`);
    };

    static getPTOReasonList = (locationId) => {
        return axiosInstanceWithToken.get(`/pto/reason/list/${locationId}/`);
    };

    static createPTOReason = (locationId, ptoReasonObj) => {
        return axiosInstanceWithToken.post(`/pto/reason/list/${locationId}/`, ptoReasonObj);
    };

    static updatePTOReason = (ptoReasonObj) => {
        return axiosInstanceWithToken.put(`/pto/reason/${ptoReasonObj.id}/`, ptoReasonObj);
    };

    static deletePTOReason = (ptoReasonId) => {
        return axiosInstanceWithToken.delete(`/pto/reason/${ptoReasonId}/`);
    };

    static getHolidayList = (locationId) => {
        return axiosInstanceWithToken.get(`/pto/holiday/list/${locationId}/`);
    };

    static AddHoliday = (locationId, holidayObj) => {
        return axiosInstanceWithToken.post(`/pto/holiday/list/${locationId}/`, holidayObj);
    };

    static updateHoliday = (holidayObj) => {
        return axiosInstanceWithToken.put(`/pto/holiday/${holidayObj.id}/`, holidayObj);
    };

    static deleteHoliday = (holidayId) => {
        return axiosInstanceWithToken.delete(`/pto/holiday/${holidayId}/`);
    };

    static getAssignedHolidayList = (settingId) => {
        return axiosInstanceWithToken.get(`/pto/holiday/assigned/list/${settingId}/`);
    };

    static CreateAssignedHoliday = (settingId, holidayObj) => {
        return axiosInstanceWithToken.post(
            `/pto/holiday/assigned/list/${settingId}/`, holidayObj
        );
    };

    static UpdateAssignedHoliday = (holidayObj) => {
        return axiosInstanceWithToken.put(
            `/pto/holiday/assigned/${holidayObj.id}/`, holidayObj
        );
    };

    static getTimeOffList = (userId) => {
        return axiosInstanceWithToken.get(`/pto/request/?user=${userId}`);
    }

    static createTimeOffRequest = (requestObj) => {
        return axiosInstanceWithToken.post(`/pto/request/`, requestObj);
    };

    static modifyTimeOffRequest = (requestObj) => {
        return axiosInstanceWithToken.put(`/pto/request/${requestObj.id}/`, requestObj);
    };

    static deleteTimeOffRequest = (requestId) => {
        return axiosInstanceWithToken.delete(`/pto/request/${requestId}`);
    };

    static getPendingRequests = (locationId) => {
        return axiosInstanceWithToken.get(`/pto/request/pending/list/${locationId}/`);
    };

    static getPendingRequestData = (requestId) => {
        return axiosInstanceWithToken.get(`/pto/request/pending/${requestId}/`);
    };

    static updatePendingRequestData = (requestObj) => {
        return axiosInstanceWithToken.put(
            `/pto/request/pending/${requestObj.id}/`, requestObj
        );
    };

    static getUserPTOInfo = (locationId, year) => {
        return axiosInstanceWithToken.get(`/pto/user/info/${locationId}/?year=${year}`);
    };

    static updateUsedPTOInfo = (locationId, infoList) => {
        return axiosInstanceWithToken.put(`/pto/user/info/${locationId}/`, infoList);
    };

    static getStaffPTOInfo = () => {
        return axiosInstanceWithToken.get(`/pto/staff/info/`);
    };

    static getLeaveList = (year) => {
        return axiosInstanceWithToken.get(`/pto/leave/list/?year=${year}`);
    };

    static getBirthdayList = (year) => {
        return axiosInstanceWithToken.get(`/pto/birthday/list/?year=${year}`);
    };

    static getUserRequests = (userId, year) => {
        return axiosInstanceWithToken.get(`/pto/request/list/all/${userId}/?year=${year}`);
    };

    static getUserList = async (locationId) => {
        return await axiosInstanceWithToken.get(`/users_except_agency_monitor/${locationId}/`);
    };

    static getIndividualPTOSetting = (settingId, userId) => {
        return axiosInstanceWithToken.get(
            `/pto/individual/setting/${settingId}/${userId}/`
        );
    };

    static updateIndividualPTOSetting = async (ptoSettingId, userId, settingObj) => {
        return await axiosInstanceWithToken.put(
            `/pto/individual/setting/${ptoSettingId}/${userId}/`, settingObj
        );
    };

    static getListOfStaffAllowed = async (settingId) => {
        return await axiosInstanceWithToken.get(`/pto/staff_allowed/list/${settingId}/`);
    };

    static getStaffAllowed = async (id) => {
        return await axiosInstanceWithToken.get(`/pto/staff_allowed/${id}/`);
    };

    static updateStaffAllowed = async (settingObj) => {
        return await axiosInstanceWithToken.put(
            `/pto/staff_allowed/${settingObj.id}/`, settingObj
        );
    };

    static getExperienceRange = async (settingId, jobTitleId) => {
        return await axiosInstanceWithToken.get(
            `/pto/experience/setting/${settingId}/${jobTitleId}/`
        );
    };

    static updateExperienceRange = async (rangeObjList, settingId, jobTitleId, copyToAll) => {
        return await axiosInstanceWithToken.put(
            `/pto/experience/setting/${settingId}/${jobTitleId}/?all=${Number(copyToAll)}`,
            rangeObjList
        );
    };

    static getOverrideSetting = (userId) => {
        return axiosInstanceWithToken.get(`/pto/override/${userId}/`);
    };

    static updateOverrideSetting = (userId, userSetting) => {
        return axiosInstanceWithToken.patch(`/pto/override/${userId}/`, userSetting);
    };

    static getUserProbationSetting = (userId) => {
        return axiosInstanceWithToken.get(`/pto/probation/user/${userId}/`);
    };

    static updateUserProbationSetting = (userId, userSetting) => {
        return axiosInstanceWithToken.patch(`/pto/probation/user/${userId}/`, userSetting);
    };

    static getBlackoutDayList = (locationId) => {
        return axiosInstanceWithToken.get(`/pto/blackout/list/${locationId}/`);
    };

    static AddBlackoutDay = (locationId, blackoutObj) => {
        return axiosInstanceWithToken.post(`/pto/blackout/list/${locationId}/`, blackoutObj);
    };

    static updateBlackoutDay = (blackoutObj) => {
        return axiosInstanceWithToken.put(`/pto/blackout/${blackoutObj.id}/`, blackoutObj);
    };

    static deleteBlackoutDay = (blackoutId) => {
        return axiosInstanceWithToken.delete(`/pto/blackout/${blackoutId}/`);
    };
}



// WEBPACK FOOTER //
// ./src/services/PTOServices.js